module.exports = __webpack_public_path__ + "img/13.88c86e2a.jpg";